var map = {
	"./discord.svg": 25243,
	"./facebook.svg": 77795,
	"./github.svg": 12788,
	"./linkedin.svg": 98008,
	"./pinterest.svg": 13957,
	"./reddit.svg": 20873,
	"./rss.svg": 52407,
	"./telegram.svg": 83338,
	"./twitter.svg": 42332,
	"./youtube.svg": 78758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49511;